<!-- =========================================================================================
  File Name: UserList.vue
  Description: Users Page
  ----------------------------------------------------------------------------------------
  Item Name: iTOVi - Admin
========================================================================================== -->

<template>
  <div>
    <div id="main-container">

      <div id="algolia-content-container" class="relative clearfix">
        <!-- Filters -->
        <vx-card class="mb-2">
          <h4>Filters</h4>
        </vx-card>

        <vx-card>
          <vs-row class="mb-4">
            <vs-col vs-w="6"></vs-col>
            <vs-col vs-w="6">
              <!-- SEARCH INPUT -->
              <vs-input class="w-full vs-input-shadow-drop vs-input-no-border d-theme-input-dark-bg mb-4"
                        type="text"
                        placeholder="Search..."
                        size="large"
                        v-model="searchFilters.filters.search"
                        v-on:keyup.enter="fetchUsers"
                        v-on:keyup.esc="searchFilters.filters.search = ''"
              />
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-w="3" v-for="(header, index) in headers" :key="index">
              <span style="font-weight: bold;">{{ header.text }}</span>
            </vs-col>
          </vs-row>

          <vs-divider></vs-divider>

          <vs-row v-for="(user) in users" :key="user.user_id" @click.native="goToUserDetail(user.user_id)" style="cursor: pointer;">
            <vs-col vs-w="3">{{ user.user_id }}</vs-col>
            <vs-col vs-w="3">{{ user.email }}</vs-col>
            <vs-col vs-w="3">{{ user.first_name }}</vs-col>
            <vs-col vs-w="3">{{ user.last_name }}</vs-col>

            <vs-divider></vs-divider>
          </vs-row>

          <!-- PAGINATION -->
          <vs-pagination

            :total="pageCount"
            :max="7"
            :value="searchFilters.pagination.page"
            @input="(val) => { searchFilters.pagination.page = val; fetchUsers(); }"
            style="justify-content: flex-end; display: flex; align-items: center; margin-left: 0%; width: 100%;"/>
        </vx-card>
      </div>
    </div>


  </div>
</template>

<script>
  import api from '@/http/api';
  import models from '@/models';
  // import ProductGeneralEditor from './components/ProductGeneralEditorCard';

  export default {
    components: {
      // ProductGeneralEditor,
      // ItemListView: () => import("./components/UserListItem.vue"),
    },
    data() {
      return {
        models: models,
        isSearchStalled: false,
        currentRefinement: true,

        companies: [new models.Company()],
        resultsPerPageOptions: [
          {label: '25', value: 25},
          {label: '50', value: 50},
          {label: '100', value: 100}
        ],
        activeOptions: [
          {label: 'Active', value: 1},
          {label: 'Inactive', value: 0},
        ],
        productTypes: [
          new models.ProductType({ product_type_id: 1, name: 'Oils' }),
          new models.ProductType({ product_type_id: 2, name: 'Supplement' }),
          new models.ProductType({ product_type_id: 3, name: 'Blend' }),
        ],
        searchFilters: {
          filters: {
            active: null,
            companies: [],
            product_types: [],
            search: '',
          },
          pagination: {
            total: 0,
            count: 10,
            page: 1,
          },
        },
        users: [],

        // Filter Sidebar
        isFilterSidebarActive: true,
        clickNotClose: true,

        headers: [
          {
            text: 'User ID',
            value: 'user_id'
          },
          {
            text: 'Email',
            value: 'email'
          },
          {
            text: 'First Name',
            value: 'first_name'
          },
          {
            text: 'Last Name',
            value: 'last_name'
          }
        ]
      }
    },
    mounted() {
      this.fetchUsers();
    },
    computed: {
      pageCount() {
        let total = this.searchFilters.pagination.total;
        let perPage = this.searchFilters.pagination.count;
        let pages = Math.floor(total / perPage);
        let plus1 = total % perPage !== 0;
        if (plus1) pages++;
        return pages;
      },

      windowWidth() {
        return this.$store.state.windowWidth
      },

      hasFilters() {
        if (this.searchFilters.filters.search) return true;
        if (this.searchFilters.filters.companies.length > 0) return true;
        if (this.searchFilters.filters.active !== null) return true;
        if (this.searchFilters.filters.product_types.length > 0) return true;

        return false;
      },
    },
    watch: {
      windowWidth() {
        this.setSidebarWidth()
      }
    },
    methods: {
      isInCart() {
        return false;
      },
      isInWishList() {
        return false;
      },
      setSidebarWidth() {
        if (this.windowWidth < 992) {
          this.isFilterSidebarActive = this.clickNotClose = false
        } else {
          this.isFilterSidebarActive = this.clickNotClose = true
        }
      },
      clearFilters() {
        this.searchFilters.filters.search = '';
        this.searchFilters.filters.companies = [];
        this.searchFilters.pagination.count = this.resultsPerPageOptions[0].value;
        this.searchFilters.pagination.page = 1;

        this.companies.forEach((company) => {
          company.isSelected = false;
        });
        this.searchFilters.filters.active = null;
        this.activeOptions.forEach((option) => {
          option.isSelected = false;
        });
        this.searchFilters.filters.product_types = [];
        this.productTypes.forEach((type) => {
          type.isSelected = false;
        });

        this.fetchUsers();
      },
      async goToUserDetail(userId) {
        console.log("T" + userId);
        // just give the UI enough time to close the dialog
        await new Promise(resolve => setTimeout(resolve, 300));
        this.$router.push(`/users/detail?id=${userId}`).catch(()=> {
        });
      },
      async fetchUsers() {
        this.$vs.loading();

        this.isSearchStalled = true;

        let usersObj = await api.fetchUsers(this.buildSearchFilters());
        this.users = usersObj.users;
        this.searchFilters.pagination.total = usersObj.pagination.total;

        this.isSearchStalled = false;

        this.$vs.loading.close();
      },

      buildSearchFilters() {
        // set companies filter
        this.searchFilters.filters.companies = this.companies.filter((company) => {
          return company.isSelected;
        }).map((company) => {
          return company.company_id;
        });
        // set product_types filter
        this.searchFilters.filters.product_types = this.productTypes.filter((type) => {
          return type.isSelected;
        }).map((type) => {
          return type.product_type_id;
        });
        // set active filter
        let selectedActive = this.activeOptions.filter((option) => {return option.isSelected});
        if (selectedActive.length !== 1) {
          this.searchFilters.filters.active = null;
        } else {
          this.searchFilters.filters.active = selectedActive[0].value;
        }

        return this.searchFilters;
      },
    },
    created() {
      this.setSidebarWidth()
    }
  }

</script>


<style lang="scss">
  #main-container {
    .algolia-header {
      .algolia-filters-label {
        width: calc(260px + 2.4rem);
      }
    }

    #algolia-content-container {

      .vs-sidebar {
        position: relative;
        float: left;
      }
    }

    .algolia-search-input-right-aligned-icon {
      padding: 1rem 1.5rem;
    }

    .algolia-price-slider {
      min-width: unset;
    }

    .item-view-primary-action-btn {
      color: #2c2c2c !important;
      background-color: #f6f6f6;
      min-width: 50%;
    }

    .item-view-secondary-action-btn {
      min-width: 50%;
    }
  }

  .theme-dark {
    #main-container {
      #algolia-content-container {
        .vs-sidebar {
          background-color: #10163a;
        }
      }
    }
  }

  @media (min-width: 992px) {
    .vs-sidebar-rounded {
      .vs-sidebar {
        border-radius: .5rem;
      }

      .vs-sidebar--items {
        border-radius: .5rem;
      }
    }
  }

  @media (max-width: 992px) {
    #algolia-content-container {
      .vs-sidebar {
        position: absolute !important;
        float: none !important;
      }
    }
  }

</style>

